import { IClient } from '@api/models';
import { Avatar, Button, Drawer } from '@hyperflake/react-ui-library';

interface ClientConfirmationDrawerProps {
    open: boolean;
    onClose: () => void;
    selectedClient: IClient[];
    isSending: boolean;
    onSend: () => void;
    title: string;
    text: string;
}

const ClientConfirmationDrawer = ({
    open,
    onClose,
    selectedClient,
    isSending,
    onSend,
    title,
    text,
}: ClientConfirmationDrawerProps) => {
    return (
        <Drawer open={open} onClose={onClose} title="Send Notification">
            <div className="space-y-6">
                {/* Notification Preview */}
                <div className="bg-primary-50 border border-primary-100 rounded-lg p-4 space-y-1">
                    <p className="text-sm font-semibold text-primary-700">{title}</p>
                    <p className="text-sm text-primary-600">{text}</p>
                </div>

                {/* Count */}
                <div className="flex items-center justify-between">
                    <h3 className="text-sm font-semibold text-grayscale-700">Selected Clients</h3>
                    <span className="text-xs font-medium bg-grayscale-100 text-grayscale-600 px-2 py-1 rounded-full">
                        {selectedClient?.length} client{selectedClient?.length !== 1 ? 's' : ''}
                    </span>
                </div>

                {/* Client List */}
                <div className="space-y-3 max-h-[400px] overflow-y-auto">
                    {selectedClient?.map((client) => (
                        <div
                            key={client._id}
                            className="flex items-center gap-3 p-2 rounded-lg border border-grayscale-100"
                        >
                            <Avatar
                                src={client?.logoUrl}
                                alt={client?.name}
                                bgColor={client?.preferences?.primaryColor}
                            />
                            <div className="overflow-hidden">
                                <p className="text-sm font-medium truncate">{client.name}</p>
                                <p className="text-xs text-grayscale-400 truncate">{client._id}</p>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="flex gap-2">
                    <Button size="sm" variant="shaded" onClick={onClose} disabled={isSending}>
                        Cancel
                    </Button>
                    <Button size="sm" color="danger" onClick={onSend} disabled={isSending}>
                        Send
                    </Button>
                </div>
            </div>
        </Drawer>
    );
};

export default ClientConfirmationDrawer;
